module.exports = __webpack_public_path__ + "media/images/btn_save_password-cacf10d163298eddcaa60ed01f16fc64.gif";